import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class AgreeBackgroundCheck extends _BaseUserProfile {
  component = 'YesNoSelection';
  props = {
    title: 'You Agree for DHC to Conduct a Background Check and Update it?',
    errorMessage: 'Please Answer on Question',
    additionalFormInModal: false,
    modalTitle: null,
    additionalFormComponent: null,
    requiredToContinue: true,
    errorRequiredMessage: 'To Proceed You Must Confirm!',
  };
}
